var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSocialFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19,
    stroke: "#C4FB71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1163 17.2028H20.8799V15.0802C20.8799 14.283 21.4082 14.0972 21.7803 14.0972C22.1516 14.0972 24.0642 14.0972 24.0642 14.0972V10.5928L20.9188 10.5806C17.4272 10.5806 16.6326 13.1942 16.6326 14.8668V17.2028H14.6133V20.8138H16.6326C16.6326 25.448 16.6326 31.0318 16.6326 31.0318H20.8799C20.8799 31.0318 20.8799 25.393 20.8799 20.8138H23.7458L24.1163 17.2028Z",
    fill: "#C4FB71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialFacebook);
export default __webpack_public_path__ + "static/media/icon-social-facebook.594de68a8f3c533de2fada48e954fa77.svg";
export { ForwardRef as ReactComponent };